import styles from "../../assets/styles/Settings/Settings.module.scss";
import React, { useState } from "react";
import { AppPage, PageLoader, MimaText, MimaButton } from "../../components";
import { AnimatePresence } from "framer-motion";
import { SecurityContainer } from "../../containers/SettingsContainer";
import Provider from "./Provider";

const Settings = ({ securityModal, goToSecurity, closeModal, loading }) => {
  const [item, setItem] = useState("SECURITY");

  return (
    <AppPage pageTitle="Settings">
      {loading ? (
        <PageLoader title="While we set things up for you" loading={loading} />
      ) : (
        <>
          <div className={styles.main}>
            <div className={styles.main__nav}>
              <div
                className={
                  item === "SECURITY"
                    ? styles.main__nav_item_active
                    : styles.main__nav_item
                }
                onClick={() => {
                  setItem("SECURITY");
                }}
              >
                <MimaText>Password & Security</MimaText>
              </div>
              <div
                className={
                  item === "TRANSFER PROVIDER"
                    ? styles.main__nav_item_active
                    : styles.main__nav_item
                }
                onClick={() => {
                  setItem("TRANSFER PROVIDER");
                }}
              >
                <MimaText>Transfer Providers</MimaText>
              </div>
            </div>

            {item === "SECURITY" && (
              <div className={styles.aside}>
                <MimaText
                  variant="subtitleBold"
                  mb={3}
                  color="var(--color-sell-main)"
                >
                  Password & Security
                </MimaText>
                <MimaButton
                  title="Change Password"
                  buttonColor="var(--color-primary)"
                  width={30}
                  mb={2}
                  onClick={goToSecurity}
                />
              </div>
            )}
            {item === "TRANSFER PROVIDER" && <Provider />}
          </div>
          {securityModal && (
            <div className="modal">
              <AnimatePresence>
                {securityModal && <SecurityContainer closeModal={closeModal} />}
              </AnimatePresence>
            </div>
          )}
        </>
      )}
    </AppPage>
  );
};
export default Settings;
